import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { debugLog } from 'shared/logger/debugLog';
import { organizationContract } from 'shared/domain/organization/organizationContract';
import { makeErrorPublisher } from 'serviceWorker/broadcasts/publishers';

const broadcastOrganizationError = makeErrorPublisher(
  organizationContract
);

/** `uniqueId` of the failed change lets its command reject with this error. */
export const broadcastUploadedOrganizationError = (
  error: unknown,
  messageId?: string | null,
  uniqueId?: string
): void => {
  debugLog('broadcastUploadedOrganizationError', error, messageId, uniqueId);
  broadcastOrganizationError(DomainMessagesTypes.failUploadedEntity, error, {
    messageId: messageId || undefined,
    uniqueId,
  });
};
